Shopify.actionTab = function() {
  const tabs = document.getElementsByClassName('js_t4_tab');

  if (!tabs.length) {
    console.error('Không tìm thấy tabs hoặc tabInfos.');
    return;
  }

  for (const tab of tabs) {
    tab.onclick = function (event){
      event.preventDefault();
      const tabWrap = event.target.closest('.tab_se_wrap');

      if (!tabWrap) {
        console.error('Không tìm thấy phần tử .tab_se_wrap.');
        return;
      }
      
      const myTabId = tab.getAttribute('data-bid');
      if (!myTabId) {
        console.error('Không tìm thấy data-bid attribute.');
        return;
      }

      const target = tabWrap.querySelector(`#${myTabId}`);
      const currentTabs = tabWrap.querySelectorAll('.js_t4_tab');
      const tabInfos = tabWrap.querySelectorAll('.tab_se_element');
      
      if (!target || !currentTabs?.length || !tabInfos?.length) {
        console.error(`Không tìm thấy phần tử với id: ${myTabId}`);
        return;
      }
      
      // Loại bỏ lớp tt_active từ tất cả các tab và thêm vào tab được click
      currentTabs.forEach(currentTab => {
        currentTab.classList.remove('tt_active');
      });
      tab.classList.add('tt_active');

      // Loại bỏ lớp ct_active từ tất cả các tabInfos và thêm vào tabInfo tương ứng
      tabInfos.forEach(tabInfo => {
        tabInfo.classList.remove('ct_active');
      });
      target.classList.add('ct_active');
    }
  }
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if(isMobile && tabs?.length > 3){
    var flkty = new Flickity(".tab_cat_title", {
      // options
      cellAlign: 'left',
      groupCells: "80%",
      freeScroll: true,
      wrapAround: true,
      draggable: true,
      lazyLoad: 2
    });
  }
}

Shopify.actionTab();